import React, { useState, useEffect } from 'react';
import './../../style/css/navigation.css';
import { NavigationEntry } from './NavigationEntry';
import { Provider, useWindowSize } from '../../models/provider';
// import LogoHeart from './../../assets/images/logo/logo_heart.svg';
import { NavLink } from 'react-router-dom';
import { NavigationBurger } from './NavigationBurger';

interface Props {
    
}

export const Navigation = (props: Props) => {
    const [isOpen, setIsOpen] = useState(true);
    const [width] = useWindowSize();

    const updateNavigationOnResize = (): void => {
        if(!isOpen && width > 750){
            setIsOpen(true);
            return;
        }        
    };

    const onChangeOpenState = (isOpen: boolean): void => {
        if(width <= 750) {
            setIsOpen(isOpen);
        }
    };

    useEffect(() => {
        const deviceWidth: number = window.innerWidth;

        //check for mobile view -> if yes -> hide navigation
        if(deviceWidth <= 750){
            setIsOpen(false);
        }
    }, []);

    updateNavigationOnResize();

    return (
        <div id="navigation">
            <NavLink to={Provider.navigationEntries[0].route} className="logo">
                <img src={"href='/images/logo_heart.svg'"} alt=""/>
            </NavLink>
            {
                isOpen ?
                <div className="routes">
                    {
                        Provider.navigationEntries.map(entry => <NavigationEntry routeEntry={entry} key={entry.id} changeNavigationState={(open: boolean) => setIsOpen(open)} />)
                    }
                </div> :
                null
            }
            <div className="navigation-burger-container">
                <NavigationBurger isOpen={isOpen} onStateChange={(open: boolean) => setIsOpen(open)} />
            </div>
        </div>
    )
};